import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router, ParamMap } from '@angular/router';
import { Observable, map } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {

    private currentRequestGuid: string | null = null;
    public requestGuid$: Observable<string | null>;

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        const findGuidRoute = (route: ActivatedRoute): ActivatedRoute | null => {
            if (route.snapshot.paramMap.has('guid')) {
                return route;
            }
            for (const child of route.children) {
                const found = findGuidRoute(child);
                if (found) {
                    return found;
                }
            }
            return null;
        };

        const guidRoute = findGuidRoute(this.activatedRoute.root);

        if (guidRoute) {

            this.currentRequestGuid = guidRoute.snapshot.paramMap.get('guid');

            this.requestGuid$ = guidRoute.paramMap.pipe(
                startWith(guidRoute.snapshot.paramMap),
                map((params: ParamMap) => {
                    this.currentRequestGuid = params.get('guid');
                    return this.currentRequestGuid;
                })
            );

        } else {

            this.currentRequestGuid = null;
            this.requestGuid$ = new Observable<string | null>(subscriber => {
                subscriber.next(null);
                subscriber.complete();
            });
        }
    }


    public get isNewRequest(): boolean {
        return !this.currentRequestGuid;
    }

    public get requestGuid(): string | null {
        return this.currentRequestGuid;
    }


    private get navigationPrefix(): string {
        return this.currentRequestGuid
            ? `/request/${this.currentRequestGuid}`
            : '/new-request';
    }

    navigate(path: string) {
        const prefix = this.navigationPrefix;
        this.router.navigate([`${prefix}/${path}`]);
    }

    public navigateWithParams(commands: any[], extras?: NavigationExtras) {
        const prefix = this.navigationPrefix;

        const firstCommand = commands[0];

        if (typeof firstCommand === 'string' && !firstCommand.startsWith('/')) {
            const fullPathCommand = `${prefix}/${firstCommand}`;
            const newCommands = [fullPathCommand, ...commands.slice(1)];
            this.router.navigate(newCommands, extras);
        } else {
            this.router.navigate(commands, extras);
        }
    }
}